import { CardsData, ScreeningCardConfig } from "./cards.types";
import OrangeCubeIcon from "@/assets/icons/orange_cube.svg?react";
import BlueCubeIcon from "@/assets/icons/blue_cube.svg?react";
import GreenCubeIcon from "@/assets/icons/green_cube.svg?react";
import DarkGreenCubeIcon from "@/assets/icons/dark_green_cube.svg?react";
import PrescriptionIcon from "@/assets/icons/app_prescriptions.svg?react";

const renderEligibilityText = (data: CardsData) => {
  const failed = data.num_criteria_failed;
  const isMet = data.ie_criteria_met === "Yes";
  return (
    <>
      {isMet ? (
        <span>
          All criteria met{" "}
          <span className="text-[#4BA06E]">({failed} failed)</span>
        </span>
      ) : (
        <span>
          Some eligibility criteria met{" "}
          <span className="text-[#980000]">({failed} failed)</span>
        </span>
      )}
    </>
  );
};

export const getCards = (data: CardsData): ScreeningCardConfig[] => {
  const baseCards: ScreeningCardConfig[] = [
    {
      key: "screening",
      title: "Screening & Eligibility",
      icon: <OrangeCubeIcon />,
      metadata: {
        "Screen Status": data.screen_status,
        "Screen Date": data.screen_date,
        "Eligibility Criteria": renderEligibilityText(data),
      },
      apiFieldNames: {
        "Screen Status": "screen_status",
        "Screen Date": "screen_date",
        "Eligibility Criteria": "ie_criteria_met",
      },
      badgeBackgroundColor: "#FEF4ED",
      badgeTextColor: "#E5945D",
    },
    {
      key: "informed-consent",
      title: "Consent Activity",
      icon: <BlueCubeIcon />,
      metadata: {
        Record: data.consent_type,
        "Consent Sent Date": data.consent_sent_date_derived,
        "Consent Signed Date": data.ic_date_signed,
        "IC Version": (
          <span>
            {data.ic_version} <span className="italic">(Last signed)</span>
          </span>
        ),
        "Protocol Version": data.protocol_version,
      },
      apiFieldNames: {
        Record: "consent_type",
        "Consent Sent Date": "consent_sent_date_derived",
        "Consent Signed Date": "ic_date_signed",
        "IC Version": "ic_version",
        "Protocol Version": "protocol_version",
      },
      badgeBackgroundColor: "#ECFAFF",
      badgeTextColor: "#0C98D0",
    },
    {
      key: "indication",
      title: "Indication",
      icon: <GreenCubeIcon />,
      metadata: {
        "Date of first diagnosis": data.first_dx_date,
        "Stage at first diagnosis": data.first_dx_stage,
        "Most Recent MMSE Score": data.test_latest_score,
        "Most Recent MMSE Score Date": data.test_latest_date_derived,
      },
      apiFieldNames: {
        "Date of first diagnosis": "first_dx_date",
        "Stage at first diagnosis": "first_dx_stage",
        "Most Recent MMSE Score": "test_latest_score",
        "Most Recent MMSE Score Date": "test_latest_date_derived",
      },
      badgeBackgroundColor: "#E8F5E8",
      badgeTextColor: "#4BA06E",
    },
    {
      key: "indication-events",
      title: "Indication Events",
      icon: <DarkGreenCubeIcon />,
      metadata: {
        "Event name": data.first_indication_event_name,
        "Onset date": data.first_indication_event_onset_date,
        "Treatment required": data.first_indication_event_treatment_required,
      },
      apiFieldNames: {
        "Event name": "indication_event_name",
        "Onset date": "onset_date_derived",
        "Treatment required": "treatment_required",
      },
      badgeBackgroundColor: "#E0EBE7",
      badgeTextColor: "#336E68",
    },
  ];

  if (data.study_arm_label) {
    baseCards.push({
      key: "study-arm",
      title: "Study Arm",
      icon: (
        <div className="flex bg-[#064C68] h-8 w-8 rounded-full items-center justify-center">
          <PrescriptionIcon />
        </div>
      ),
      metadata: {
        "Study Arm Label": data.study_arm_label,
      },
      apiFieldNames: {
        "Study Arm Label": "study_arm_label",
      },
      badgeBackgroundColor: "#E5F0F5",
      badgeTextColor: "#064C68",
    });
  }
  return baseCards;
};
